module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module"
  }, [_c('ModuleCard', _vm._b({}, 'ModuleCard', _vm.item, false)), _c('div', {
    staticClass: "module__thems"
  }, [_c('h3', {
    staticClass: "module__title"
  }, [_vm._v("Темы модуля:")]), (_vm.item.themes && _vm.item.themes.length) ? _c('ul', {
    staticClass: "module__list"
  }, _vm._l((_vm.item.themes), function(ref, index) {
    var name = ref.name;

    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(name))])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c675fcc4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/modules/components/module/Module.vue
// module id = 79e8651fabdc426cded8
// module chunks = 5